// createWorkspace.js
import { createWorkspaceApi } from './api';
import { isNonEmpty } from './validation';

export default async function createWorkspace({
  name,
  description,
  templateId,
  members,

  // Nya f�lt fr�n SummaryEditor:
  storageGB,
  icon,        // t.ex. "mdi:book-open"
  color,       // t.ex. "#6a2135"
  imageUrl,    // dataURL eller http(s)-URL
  template,
  owner,
  orderGroup,
  network,
  menus,
  roles,
  dashboard,
  startPage,
}) {
  if (!isNonEmpty(name)) throw new Error('Name is required');

  const payload = {
    name: name.trim(),
    description: (description || '').trim(),
    templateId: templateId || null,
    members: Array.isArray(members) ? members : [],

    // Nya f�lt med s�kra fallbacks:
    storageGB: Number.isFinite(storageGB) ? storageGB : 1,
    icon: icon || null,
    color: color || null,
    imageUrl: imageUrl || null,
    template: template || null,
    owner: owner || null,
    orderGroup: orderGroup || null,
    network: network || null,
    menus: Array.isArray(menus) ? menus : [],
    roles: Array.isArray(roles) ? roles : [],
    dashboard: dashboard || null,
    startPage: startPage || null,
  };

  return await createWorkspaceApi(payload);
}
